import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';
// Extends From
// Ember Imports
import { isPresent } from '@ember/utils';
// Internal Imports
import NotificationPreference from '@linc-technologies/linced-common/enums/person-option-notification-preference';

export default class Person extends DynamicFieldsSerializer {
  normalize(modelClass, payload) {
    // If a Learner is returned by the server with no homeroomId, force it to an empty string.
    // This covers the case where the server returns a partial record to say that a Learner has
    // been removed from a Homeroom, as the server may omit the homeroomId if empty.
    if (isPresent(payload.learner) && !isPresent(payload.learner.homeroomId)) {
      payload.learner.homeroomId = null;
    }

    // Inject default user options due to omit empty.
    if (!payload.options) {
      payload.options = {};
    }
    if (!payload.options.notificationPreference) {
      payload.options.notificationPreference = NotificationPreference.DEFAULT;
    }

    // Initialise datacards with default empty arrays if it doesn't exist
    if (!payload.options.datacards) {
      payload.options.datacards = {
        assessmentIds: [],
        assesmentModuleIds: [],
        subjectIds: [],
        progressIds: [],
      };
    } else {
      // Ensure all datacards properties exist
      if (!payload.options.datacards.assessmentIds) {
        payload.options.datacards.assessmentIds = [];
      }
      if (!payload.options.datacards.assesmentModuleIds) {
        payload.options.datacards.assesmentModuleIds = [];
      }
      if (!payload.options.datacards.subjectIds) {
        payload.options.datacards.subjectIds = [];
      }
      if (!payload.options.datacards.progressIds) {
        payload.options.datacards.progressIds = [];
      }
    }

    // If we have postCounts, transform them into a map rather than an array of objects.
    if (isPresent(payload.postCounts)) {
      let counts = {};
      for (let i = 0; i < payload.postCounts.length; i++) {
        let count = payload.postCounts[i];
        counts[count.type] = count.items || [];

        for (let j = 0; j < counts[count.type].length; j++) {
          counts[count.type][j].itemId = counts[count.type][j].id;
        }
      }
      payload.postCounts = counts;
    }

    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);

    // If we have postCounts, transform them back from a map into an array of objects.
    if (isPresent(hash.postCounts)) {
      let counts = [];
      Object.keys(hash.postCounts).forEach(function (key) {
        let items = hash.postCounts[key];
        items.forEach(function (item) {
          item.id = item.itemId;
          delete item.itemId;
        });
        counts.push({
          type: key,
          items,
        });
      });
      hash.postCounts = counts;
    }

    return hash;
  }
}
